const Meta = () => (
  <svg
    width="81"
    height="16"
    viewBox="0 0 81 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_33_266)">
      <path
        d="M2.63607 10.5516C2.63607 11.4714 2.84061 12.1776 3.10795 12.6048C3.45847 13.1644 3.98127 13.4015 4.51426 13.4015C5.20171 13.4015 5.8306 13.2331 7.04255 11.5786C8.01346 10.2526 9.15752 8.3912 9.92729 7.22429L11.2309 5.24733C12.1365 3.87435 13.1846 2.34806 14.3864 1.31351C15.3675 0.46911 16.4258 0 17.4909 0C19.2792 0 20.9825 1.02283 22.2861 2.94115C23.7128 5.04209 24.4053 7.68838 24.4053 10.4193C24.4053 12.0427 24.0811 13.2356 23.5295 14.178C22.9965 15.0894 21.9577 16 20.2102 16V13.4015C21.7065 13.4015 22.0799 12.0444 22.0799 10.4913C22.0799 8.27812 21.5571 5.82199 20.4054 4.06702C19.5881 2.8222 18.5289 2.06157 17.3636 2.06157C16.1033 2.06157 15.0891 2.99979 13.9493 4.67267C13.3433 5.56147 12.7212 6.64461 12.0227 7.86681L11.2538 9.21131C9.70918 11.9146 9.31792 12.5303 8.5456 13.5464C7.19192 15.3257 6.03598 16 4.51426 16C2.70906 16 1.56756 15.2285 0.860586 14.0658C0.283467 13.1183 0 11.8752 0 10.4586L2.63607 10.5516Z"
        fill="#0081FB"
      />
      <path
        d="M2.07849 3.12461C3.28705 1.28586 5.03113 0 7.03153 0C8.19001 0 9.3417 0.338429 10.5443 1.30764C11.8598 2.36733 13.2619 4.11225 15.011 6.98806L15.6382 8.0201C17.1523 10.5097 18.0138 11.7906 18.5179 12.3946C19.1663 13.1703 19.6204 13.4015 20.2102 13.4015C21.7065 13.4015 22.0799 12.0444 22.0799 10.4913L24.4053 10.4193C24.4053 12.0427 24.0811 13.2356 23.5295 14.178C22.9965 15.0894 21.9577 16 20.2102 16C19.1239 16 18.1614 15.7671 17.0972 14.7761C16.279 14.0155 15.3225 12.6643 14.5867 11.4496L12.3979 7.84084C11.2997 6.02974 10.2922 4.67937 9.70919 4.06785C9.082 3.41026 8.27573 2.61613 6.98909 2.61613C5.94773 2.61613 5.06338 3.33738 4.32331 4.44063L2.07849 3.12461Z"
        fill="url(#paint0_linear_33_266)"
      />
      <path
        d="M6.98908 2.61613C5.94772 2.61613 5.06337 3.33738 4.3233 4.44063C3.27685 5.99958 2.63607 8.32167 2.63607 10.5516C2.63607 11.4714 2.84061 12.1776 3.10795 12.6048L0.860586 14.0658C0.283467 13.1183 0 11.8752 0 10.4586C0 7.88272 0.716306 5.19791 2.07848 3.12461C3.28703 1.28586 5.03112 0 7.03151 0L6.98908 2.61613Z"
        fill="url(#paint1_linear_33_266)"
      />
      <path
        d="M29.5298 0.505981H32.5792L37.7639 9.7642L42.9495 0.505981H45.9327V15.7185H43.4451V4.05949L38.8978 12.1332H36.5638L32.0173 4.05949V15.7185H29.5298V0.505981ZM53.7272 6.17802C51.9432 6.17802 50.8688 7.50326 50.6116 9.14431H56.6662C56.5415 7.45384 55.5536 6.17802 53.7272 6.17802ZM48.1453 10.0792C48.1453 6.62619 50.4062 4.1131 53.7705 4.1131C57.0796 4.1131 59.0554 6.59436 59.0554 10.2635V10.9378H50.6116C50.9112 12.7229 52.1113 13.9259 54.0463 13.9259C55.5901 13.9259 56.5551 13.461 57.47 12.6107L58.7914 14.2082C57.5464 15.3382 55.9627 15.99 53.958 15.99C50.3162 15.99 48.1453 13.3688 48.1453 10.0792ZM62.0716 6.39582H59.7818V4.38535H62.0716V1.06054H64.4718V4.38535H67.9506V6.39582H64.4718V11.4915C64.4718 13.2314 65.0353 13.8496 66.4204 13.8496C67.0527 13.8496 67.4151 13.796 67.9506 13.7081V15.6968C67.2835 15.8827 66.647 15.9682 65.9579 15.9682C63.3668 15.9682 62.0716 14.5709 62.0716 11.7738V6.39582ZM78.057 8.35101C77.5749 7.14975 76.4996 6.26514 74.9193 6.26514C72.8655 6.26514 71.5508 7.70347 71.5508 10.0465C71.5508 12.3309 72.7611 13.8388 74.8209 13.8388C76.4402 13.8388 77.5961 12.9089 78.057 11.7521V8.35101ZM80.4571 15.7185H78.1011V14.132C77.4425 15.066 76.2442 15.99 74.3032 15.99C71.1816 15.99 69.0955 13.4107 69.0955 10.0465C69.0955 6.65048 71.2317 4.1131 74.4356 4.1131C76.0192 4.1131 77.2617 4.73802 78.1011 5.84127V4.38535H80.4571V15.7185Z"
        fill="#192830"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_33_266"
        x1="5.17711"
        y1="9.80105"
        x2="21.9803"
        y2="10.6608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0064E1" />
        <stop offset="0.4" stopColor="#0064E1" />
        <stop offset="0.83" stopColor="#0073EE" />
        <stop offset="1" stopColor="#0082FB" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_33_266"
        x1="3.81917"
        y1="11.644"
        x2="3.81917"
        y2="5.5288"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#0082FB" />
        <stop offset="1" stopColor="#0064E0" />
      </linearGradient>
      <clipPath id="clip0_33_266">
        <rect width="80.4571" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Meta;
